import React from 'react';
import { FaStar } from 'react-icons/fa';

const reviews = [
  {
    name: "Mithilesh Rajendra Jogale",
    institute: "NMI of Engineering and Technology, CSE",
    rating: 4,
    text: "Internship was very good the task assigned were nice and we learned so many new things from it."
  },
  {
    name: "Rakshita Sharma",
    institute: "Vellore Institute of Technology-Bhopal, (CSE)",
    rating: 5,
    text: "The cyber security training and internship program is well-structured, providing a comprehensive curriculum covering various technical skills needed in the field of cyber security."
  },
  {
    name: "Aryan Sharma",
    institute: "AIMETC, Jalandhar, Punjab",
    rating: 4,
    text: "Absolutely good course learned various things like burpsuit, networking, projects."
  },
  {
    name: "A. Jotheeswar",
    institute: "SGS ARTS COLLEGE, Bsc Computer Science",
    rating: 5,
    text: "The explanation on course basic concepts are well but I expected more than those yet learnt by myself. Overall course is satisfactory with 3 star rating."
  },
  {
    name: "Shubham S. Shinde",
    institute: "MET BKC Institute of Engineering, Nashik",
    rating: 4,
    text: "Aman Gupta sir's two-month cyber security training was exceptionally informative, blending practical insights with engaging teaching. His expertise, timely clarifications, and focus on governance in cyber incident response were invaluable, making the program impactful and relevant."
  },
  {
    name: "Acitya Kumar",
    institute: "NOIDA INTERNATIONAL UNIVERSITY (BCA)",
    rating: 5,
    text: "The internship program went really well and it was really good. The mentors were really good and knowledgeable. I fully satisfied and had a good experience with this Internship program with the Interns Elite."
  }
];

function CS_Review_Program_Page() {
  return (
    <div>
      <div>
        <div className='container'>
          <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
              <div className='text-center review_component_text'>
                <h2 className='display-5 pb-2'>Testimonial</h2>
                <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
              </div>
            </div>
            <div className='col-md-1'></div>
          </div>
          <div className='row'>
            <div className='col-md-4 pt-5'>
              <div className='Program_review_comp'>
                <div className='mt-5 px-5 review_component_text'>
                  <h2 className='pt-5 display-6'>Hear What Our Students Says</h2>
                  <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                </div>
              </div>
            </div>
            <div className='col-md-8'>
              <div className='row'>
                {reviews.map((review, index) => (
                  <div key={index} className={`col-md-${index % 2 === 0 ? '5' : '7'} card`}>
                    <div className='card-body'>
                      <h5 className='font-weight-bold Review_not_copy'>{review.name}</h5>
                      <h6 className='font-weight-bold my-2 Review_not_copy'>{review.institute}</h6>
                      <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                        {[...Array(5)].map((_, i) => (
                          <li key={i}>
                            <FaStar color={i < review.rating ? "gold" : "gray"} />
                          </li>
                        ))}
                      </ul>
                      <p className="Review_not_copy">
                        <i className="fas fa-quote-left pe-2"></i>{review.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CS_Review_Program_Page;
